module.exports = __webpack_public_path__ + "img/taiwanband.341347a4.jpg";